<div class="flex gap-2 flex-wrap align-items-end mb-3" *ngIf="canSeeInfrastructure || canSeeDatabase">
    <div class="input-field" style="min-width:190px">
        <label for="period">Periodo</label>
        <p-dropdown [options]="periodOptions" optionLabel="name" optionValue="value"
            [(ngModel)]="period" (onChange)="refresh(); loadUsers()" [disabled]="loading" styleClass="w-full" appendTo="body"></p-dropdown>
    </div>
    <div class="input-field flex">
        <button pButton ngClass="mt-3" label="Actualizar" icon="pi pi-refresh" [disabled]="loading" (click)="refresh(); loadUsers()"></button>
    </div>

    <!-- empujado con ml-auto: periodo y "Actualizar" se quedan a la izquierda, refresco automático
         y la marca de hora al extremo derecho. Son independientes de "period": cambiar el periodo
         no reinicia este temporizador, y elegir un intervalo no cambia el periodo. -->
    <div class="input-field ml-auto" style="min-width:170px">
        <label for="autoRefreshInterval">Refresco automático</label>
        <p-dropdown [options]="autoRefreshOptions" optionLabel="name" optionValue="value"
            [(ngModel)]="autoRefreshInterval" (onChange)="onAutoRefreshChange()" styleClass="w-full" appendTo="body"></p-dropdown>
    </div>

    <div class="input-field flex align-items-center" *ngIf="loading">
        <span class="mt-3 text-color-secondary"><i class="pi pi-spin pi-spinner mr-1"></i>Actualizando…</span>
    </div>
    <div class="input-field flex align-items-center" *ngIf="refreshedAt && !loading">
        <span class="mt-3 text-color-secondary">Datos a las {{ refreshedAt | date:'HH:mm:ss' }}</span>
    </div>
</div>

<!-- sin ninguno de los dos permisos no hay nada que pintar: ni cabecera (no hay nada que
     actualizar) ni pestañas. Un p-tabView vacío se leería como "todo va bien"; este mensaje deja
     claro que es un permiso que falta, no una avería. -->
<p-messages severity="info" *ngIf="!canSeeInfrastructure && !canSeeDatabase">
    <ng-template pTemplate>
        <div class="ml-2">Este panel requiere el permiso PLATFORM_HEALTH.INFRASTRUCTURE (capa de API compartida) o PLATFORM_HEALTH.DATABASE (base de datos de este inquilino). Puede concedérselos un administrador desde Roles.</div>
    </ng-template>
</p-messages>

<!-- un bloque degradado dice por qué, en lugar de dejar el hueco vacío. Van fuera del p-tabView y
     visibles desde cualquier pestaña: si Azure no responde, eso no puede quedar escondido detrás de
     una pestaña que el usuario no ha abierto. -->
<p-messages severity="warn" *ngIf="canSeeInfrastructure && platform?.status?.status === 'unavailable'">
    <ng-template pTemplate>
        <div class="ml-2">Plataforma: {{ platform?.status?.reason }}</div>
    </ng-template>
</p-messages>
<p-messages severity="warn" *ngIf="canSeeDatabase && database?.status?.status === 'unavailable'">
    <ng-template pTemplate>
        <div class="ml-2">Base de datos: {{ database?.status?.reason }}</div>
    </ng-template>
</p-messages>
<p-messages severity="warn" *ngIf="canSeeInfrastructure && appInsights?.status?.status === 'unavailable'">
    <ng-template pTemplate>
        <div class="ml-2">Application Insights: {{ appInsights?.status?.reason }}</div>
    </ng-template>
</p-messages>
<p-messages severity="warn" *ngIf="canSeeDatabase && sessions?.status?.status === 'unavailable'">
    <ng-template pTemplate>
        <div class="ml-2">Sesiones: {{ sessions?.status?.reason }}</div>
    </ng-template>
</p-messages>
<p-messages severity="warn" *ngIf="canSeeDatabase && users?.status?.status === 'unavailable'">
    <ng-template pTemplate>
        <div class="ml-2">Usuarios de la base: {{ users?.status?.reason }}</div>
    </ng-template>
</p-messages>

<p-tabView *ngIf="canSeeInfrastructure || canSeeDatabase">
    <!-- "Visión global" aparece siempre que se pueda llenar con al menos un grupo de permisos: es
         la pestaña por defecto y no depende de cuál de los dos permisos tenga el usuario -->
    <p-tabPanel header="Visión global">
        <app-platform-health-overview
            [canSeeInfrastructure]="canSeeInfrastructure"
            [canSeeDatabase]="canSeeDatabase"
            [platform]="platform"
            [database]="database"
            [appInsights]="appInsights"
            [trafficChart]="trafficChart"
            [latencyChart]="latencyChart"
            [databaseChart]="databaseChart"
            [poolChart]="poolChart"
            [chartOptions]="chartOptions"
            [trafficChartOptions]="trafficChartOptions"></app-platform-health-overview>
    </p-tabPanel>

    <p-tabPanel header="API" *ngIf="canSeeInfrastructure">
        <app-platform-health-api
            [platform]="platform"
            [appInsights]="appInsights"
            [trafficChart]="trafficChart"
            [latencyChart]="latencyChart"
            [appServiceChart]="appServiceChart"
            [threadsChart]="threadsChart"
            [chartOptions]="chartOptions"
            [trafficChartOptions]="trafficChartOptions"
            [appServiceChartOptions]="appServiceChartOptions"></app-platform-health-api>
    </p-tabPanel>

    <p-tabPanel header="Base de datos" *ngIf="canSeeDatabase">
        <app-platform-health-database
            [database]="database"
            [users]="users"
            [sessions]="sessions"
            [canKillSession]="canKillSession"
            [databaseChart]="databaseChart"
            [poolChart]="poolChart"
            [chartOptions]="chartOptions"
            (killSession)="onKillSession($event)"></app-platform-health-database>
    </p-tabPanel>
</p-tabView>

<!-- confirmación explícita antes de cortar una sesión: la pide onKillSession() con el login, la
     aplicación y el tiempo transcurrido de la fila pulsada. -->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
